import SvgColor from "../../../components/svg-color";

const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const navConfig = [
  {
    title: "Companies",
    path: "/companies-listing",
    icon: icon("ic_listing"),
  },
  {
    title: "Investors",
    path: "/investors-listing",
    icon: icon("ic_listing"),
  },
  {
    title: "Feedbacks",
    path: "/feedbacks",
    icon: icon("ic_listing"),
  },
  { title: "Register User", icon: icon("ic_listing"), action: "registerUser" },
];

export default navConfig;
